import styled from 'styled-components';
import { Card, Divider, Dropdown, InlineBanner, List, textStyles, token } from '@bynder/design-system';

// Styles are absolute ass
// due to inability to style DS modal properly
// and lack of passed properties DS modal
export const StyledModalContainer = styled.div`
    & > div > div.react-responsive-modal-container {
        justify-content: start;
    }

    & > div > div.react-responsive-modal-container > div {
        height: 100%;
        grid-template-columns: auto minmax(520px, 21vw);
    }

    & > div > div.react-responsive-modal-container > div > :first-child {
        border-bottom: 1px solid ${token.gray100a};
    }

    & > div > div.react-responsive-modal-container > div > :nth-child(2) > div {
        padding-top: ${token.spacing4};
        padding-inline: 0;
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;

        &::before {
            content: none;
        }
    }

    & > div > div.react-responsive-modal-container > div > :nth-child(2) {
        display: flex;
        flex-direction: column;
        overflow: hidden;
    }
`;

export const ModalContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
`;

export const ScrollableListContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
`;

export const StyledDivider = styled(Divider)`
    margin: 0 calc(${token.spacing6} * -1);
`;

export const ListItemContent = styled(List.Item)``;

export const ButtonWrapper = styled.div<{ $isVisible: boolean }>`
    /* Show when dropdown is opened */
    opacity: ${(props) => (props.$isVisible ? '1' : '0')};

    /* Show when parent component is hovered */
    ${ListItemContent}:hover & {
        opacity: 1;
    }
`;

export const StyledSectionTitle = styled(Dropdown.SectionTitle)`
    white-space: normal;
    overflow-wrap: break-word;

    ${textStyles.uiTextS}
    font-weight: 500;
`;

export const StyledSectionItem = styled(Dropdown.SectionTitle)`
    white-space: normal;
    overflow-wrap: break-word;

    ${textStyles.paragraphS}
    color: ${token.colorTextMuted};

    svg {
        margin-right: ${token.spacing3};
        color: ${token.colorTextMuted};
    }
`;

export const StyledInlineBanner = styled(InlineBanner)`
    margin: ${token.spacing3} ${token.spacing5};
    background-color: ${token.red50};

    & > div > div {
        color: ${token.colorTextMuted};
    }
`;

// Custom size of the Card to fit into the grid
export const CARD_MIN_SIZE = 215;
export const StyledCard = styled(Card)`
    & > button > div {
        min-height: ${CARD_MIN_SIZE}px;
    }
`;

export const DisabledCardWrapper = styled.div`
    & > div > button {
        cursor: unset !important;
        opacity: 0.5;
    }
`;
